var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item-content',[_c('v-list-item-subtitle',{staticClass:"caption"},[_vm._v(_vm._s(_vm.date))]),_c('v-list-item-title',[_vm._v(" Anotação • "+_vm._s(_vm.reminder.remindable.lead.identifier_code)+" ")]),_c('v-list-item-subtitle',{staticClass:"text-wrap"},[_vm._v(_vm._s(_vm.content.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }